import "@/styles/review/reviews.scss";

const countryName = [
    { name: "Thailand" },
    { name: "Maldives" },
    { name: "Dubai" },
    { name: "Singapore" },
    { name: "Malaysia" },
    { name: "Bali" },
    { name: "Andaman" },
    { name: "Vietnam" },
    { name: "HongKong" },
    { name: "Azerbaijan" },
];

export default function TabLink() {
    return (
        <div
            id="customer-stories"
            className="category-tab flex gap-4 justify-left px-6 overflow-x-auto 2xl:overflow-hidden scrollbar-hide whitespace-nowrap container mx-auto"
        >
            <a href="/reviews">
                <div className="px-4 py-2 rounded-lg bg-[#FF4514] text-white">
                    All Reviews
                </div>
            </a>
            {countryName.map((item, index) => (
                <a
                    href={`/reviews/${item.name
                        .toLowerCase()
                        .replace(/\s+/g, "-")}`}
                    key={index}
                >
                    <div className="px-4 py-2 rounded-lg bg-[#FF4514] text-white">
                        {item.name}
                    </div>
                </a>
            ))}
        </div>
    );
}
